import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';

const FarmNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { values } = useFormikContext();

  return (
    <FormikInput
      value={values.farmNumber}
      placeholder="Enter farm number"
      name="farmNumber"
      label="Farm Number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default FarmNumber;
